import { initializeApp } from 'firebase/app';
import { getMessaging, Messaging } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyAaHheKgOkAWou77xSUQecnvUADWkPSTGM",
  authDomain: "sconscious-42c54.firebaseapp.com",
  projectId: "sconscious-42c54",
  storageBucket: "sconscious-42c54.appspot.com",
  messagingSenderId: "395740383288",
  appId: "1:395740383288:web:32fb76be6795b51aadbecd",
  measurementId: "G-8TCN9FY3HX"
};

export const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);
